import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/style/global.scss"
// import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
import Carousel3d from 'vue-carousel-3d';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)
Vue.use(Carousel3d);
Vue.use(BootstrapVue)
// Vue.use(LottieAnimation); 
Vue.config.productionTip = false

new Vue({

  render: h => h(App)
}).$mount('#app')
